import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Sticky CTA Bar — vizibila doar pe mobile, fixata jos.
 * Apare dupa ce userul scroleaza > 600px (dupa hero), pentru a nu compete cu CTA-ul principal.
 *
 * Props:
 *   - onDemoClick: () => void — callback pentru "Solicita demo"
 */
export default function StickyCTABar({ onDemoClick }) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className="sticky-cta-bar"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: '#FFFFFF',
        borderTop: '1px solid #E5E7EB',
        boxShadow: '0 -8px 24px rgba(13,27,42,0.1)',
        padding: '12px 16px',
        display: 'flex',
        gap: 10,
        zIndex: 1000,
        transform: visible ? 'translateY(0)' : 'translateY(100%)',
        transition: 'transform 0.3s ease',
      }}
    >
      <Link
        to="/register"
        style={{
          flex: 1,
          padding: '12px 16px',
          background: 'transparent',
          color: '#0A1428',
          textDecoration: 'none',
          textAlign: 'center',
          border: '1.5px solid #0A1428',
          borderRadius: 10,
          fontFamily: 'Inter, system-ui, sans-serif',
          fontSize: 13,
          fontWeight: 600,
        }}
      >
        {t('app.sticky_cta.free_account')}
      </Link>
      <button
        type="button"
        onClick={onDemoClick}
        style={{
          flex: 1.4,
          padding: '12px 16px',
          background: 'linear-gradient(135deg, #D4AF37 0%, #B8972E 100%)',
          color: '#0A1428',
          border: 'none',
          borderRadius: 10,
          fontFamily: 'Inter, system-ui, sans-serif',
          fontSize: 13,
          fontWeight: 700,
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(212,175,55,0.3)',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 6,
        }}
      >
        ✦ {t('app.sticky_cta.request_demo')}
      </button>
    </div>
  );
}
